import React from 'react';
import Quote from './fetch-data';

const QuotePage = () => (
  <div className="quote-container">
    <Quote />
  </div>
);
export default QuotePage;
